import React from 'react'
import { useLocation } from 'react-router'
import './AiPrivacyFooter.css'

const PRIVACY_URL = 'https://plode.org/privacy-policy'

const AI_ROUTES = [
    // '/ai-project',
    // '/ai-showcase',
    // '/ai-code',
    // '/aiCodeConfigure',
    // '/aiCodeConfigureAudio',
    // '/aiCodeFlow',
    // '/aiExecute',
    // '/webAiPlay',
    // '/vision',
    '/Selection'
]

const AiPrivacyFooter = () => {
    const { pathname } = useLocation()
const isWebAiMode =
        sessionStorage.getItem('webAiMode') === 'true'
    if (!AI_ROUTES.includes(pathname)) return null

    return (
        isWebAiMode ?<footer className="aiPrivacyFooter" aria-label="Privacy information">
            {/* <span className="aiPrivacyFooter__text">
                Plode © 2026
            </span>

            <span className="aiPrivacyFooter__separator">·</span>

            <span className="aiPrivacyFooter__text">
                All rights reserved
            </span>

            <span className="aiPrivacyFooter__separator">·</span> */}

            <a
                className="aiPrivacyFooter__link"
                href={PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
            >
                Privacy Policy
            </a>
        </footer>:<></>
    )
}

export default AiPrivacyFooter